export const LOAD_SUMMER_COURSES = 'LOAD_SUMMER_COURSES';